export const GET_INVOICE_USER = "GET_INVOICE_USER";
export const GET_EMP_USER = "GET_EMP_USER";
export const GET_ALL_USER = "GET_ALL_USER"
export const GET_STAFF_USERS = "GET_STAFF_USER"
export const BIRTHDAY_USERS = "BIRTHDAY_USERS"
